import {createReducer} from "./index";
import {convertToDate} from "../projections";

import * as R from 'ramda';
import {ADD_PUNCH_LIST_ITEMS} from "../actions/punchList";

/*
Structure of punchlist model:

{
  data: {
    [uuid]: {
      permissions: {
        // these are returned by the backend; may not be up to date
        view: bool
        update: bool
        delete: bool
      }
      resource: {
        // these are returned by the backend; may not be up to date
        id: string // uuid
        projectid: string // uuid
        name: string
        description: string
        status: string // code-drive code_punchlistitemstatus
        createdbyuserid: string // uuid
        owneruserid: string // uuid
        createdbycompanyid: string // uuid
        ownercompanyid: string // uuid
        active: bool
        priority: string // code-drive code_punchlistitempriority
        duedate: date
        number: string
        datecreated: datetime
        abbreviation: string
      }
    }
  }
  indexes: {
    // used for indexing entries by different fields other than the id field
    projectid: {
      [projectid]:
        [punchitemid]: dontcare
    }
  }

}
 */


const punchListInitial = {
  data: {},
  indexes: {
    projectid: {}
  },
};


const punchListReducer = createReducer(punchListInitial,
  {
    [ADD_PUNCH_LIST_ITEMS]: (state, action) => {
      let newState = state;
      action.payload.forEach(item => {
        item.resource.duedate = convertToDate(item.resource.duedate);
        item.resource.datecreated = convertToDate(item.resource.duedate);
        newState = R.over(R.lensPath(['data', item.resource.id]), () => item)(newState);
        newState = R.over(R.lensPath(['indexes', 'projectid', item.resource.projectid]), value => {
          if (!value) {
            return {[item.resource.id]: 1};
          } else {
            return {...value, [item.resource.id]: 1};
          }
        })(newState);
      });
      return newState;
    }

    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default punchListReducer;



// WEBPACK FOOTER //
// ./src/reducers/punchList.js